module.exports = __webpack_public_path__ + "img/share_guide.2db45d68.svg";